export default "__VITE_ASSET__CR96DxBC__"